import { render, staticRenderFns } from "./ProductOrderingNew.vue?vue&type=template&id=4fdda881&scoped=true"
import script from "./ProductOrderingNew.vue?vue&type=script&lang=js"
export * from "./ProductOrderingNew.vue?vue&type=script&lang=js"
import style0 from "./ProductOrderingNew.vue?vue&type=style&index=0&id=4fdda881&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdda881",
  null
  
)

export default component.exports